import { render, staticRenderFns } from "./CorrectiveActionList.vue?vue&type=template&id=09700c79"
import script from "./CorrectiveActionList.vue?vue&type=script&lang=js"
export * from "./CorrectiveActionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports